import React, { useState, useEffect } from "react";

const Clock = ({ timezone }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatTime = () => {
    try {
      return new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }).format(time);
    } catch (error) {
      console.error("Time formatting error:", error);
      return "Invalid timezone";
    }
  };

  return (
    <div className="clock-container">
      <div className="time-display">{formatTime()}</div>
    </div>
  );
};

export default Clock;
